import {
    registerComponent,
    registerStore,
    registerDirective
} from '~lib/storefront';
import {
    registerApp,
    CalendarDesktopApp,
    CalendarMiniApp,
    SearchSuggestions,
    SearchEmptyListSuggestions
} from '~/vue';
import swHeader from '../alpine/components/sw/sw-header';
import swHeaderSearch from '../alpine/components/sw/sw-header-search';
import swMinicart from '../alpine/components/sw/sw-minicart';
import swMobileNav from '../alpine/components/sw/sw-mobile-nav';
import swMenu from '../alpine/components/sw/sw-menu';
import swBlogCategoryLink from '../alpine/components/sw/blog/sw-blog-category-link';
import swSlider from '../alpine/components/sw/sw-slider';
import swSidebar from '../alpine/components/sw/sw-sidebar';
import swBlogPostContent from '../alpine/components/sw/blog/sw-blog-post-content';
import swBlogToolbarSorter from '../alpine/components/sw/blog/sw-blog-toolbar-sorter';
import swModal from '../alpine/components/sw/sw-modal';
import swSearch from '../alpine/components/sw/sw-search';
import stickyBlock from '../alpine/directives/sticky-block';
import minicart from '../alpine/stores/minicart';

/** Alpine components */
registerComponent('swHeader', swHeader);
registerComponent('swHeaderSearch', swHeaderSearch);
registerComponent('swMinicart', swMinicart);
registerComponent('swMobileNav', swMobileNav);
registerComponent('swMenu', swMenu);
registerComponent('swBlogCategoryLink', swBlogCategoryLink);
registerComponent('swSlider', swSlider);
registerComponent('swSidebar', swSidebar);
registerComponent('swBlogPostContent', swBlogPostContent);
registerComponent('swBlogToolbarSorter', swBlogToolbarSorter);
registerComponent('swModal', swModal);
registerComponent('swSearch', swSearch);

/** Alpine directives */
registerDirective('sticky-block', stickyBlock);

/** Alpine stores */
registerStore('minicart', minicart);

/** Vue apps */
registerApp('#search-suggestions', SearchSuggestions, {
    inputSelector: '#search'
});
registerApp('#header-search-suggestions', SearchSuggestions, {
    inputSelector: '#header-search'
});
registerApp('#calendar-desktop-app', CalendarDesktopApp);
registerApp('#calendar-mini-app', CalendarMiniApp);
registerApp('#search-empty-list-suggestions', SearchEmptyListSuggestions);
